<template>
    <v-container class="py-5 px-5" fluid>
        <v-layout justify-start>
            <v-flex class="px-2 py-2">
                <v-btn @click="flippedy=!flippedy" v-if="flippedy" color="success"> Show Cookie Policy </v-btn>
                <v-btn @click="flippedy=!flippedy" v-if="!flippedy" color="success"> Show Privacy Notice </v-btn>
            </v-flex>
        </v-layout>
        <v-flex xs12 v-if="flippedy">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Privacy Notice
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <div  v-for="(entry, key) in priv" :key="key">
                        <div v-if="entry.headers">
                            <h1 :style="$store.state.textFormatting.main" v-for="header in entry.headers" :key="header"> <b :style="$store.state.textFormatting.main"> {{header}} </b> </h1>
                        </div>
                        <div v-for="main in entry.main" :key="main" :style="$store.state.textFormatting.main">
                            <h2 :style="$store.state.textFormatting.main" class="font-weight-medium"> {{main}} </h2>
                            <br />
                        </div>
                        <ul v-if="entry.list">
                            <li v-for="item in entry.list" :key="item" :style="$store.state.textFormatting.main">
                                <h2 :style="$store.state.textFormatting.main" class="font-weight-medium"> {{item}} </h2>
                            </li>
                        </ul>
                        <br v-if="entry.list" />
                    </div>
                </v-card-text>
            </v-card>
            <br />
        </v-flex>
        <v-flex xs12 v-if="!flippedy">
            <v-card>
                <v-toolbar dark flat color="secondary">
                    <v-toolbar-title :style="$store.state.textFormatting.headers">
                        Cookie Policy
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <div  v-for="(entry, key) in cookiemonster" :key="key">
                        <div v-if="entry.headers">
                            <h1 :style="$store.state.textFormatting.main" v-for="header in entry.headers" :key="header"> <b :style="$store.state.textFormatting.main"> {{header}} </b> </h1>
                        </div>
                        <div v-for="main in entry.main" :key="main" :style="$store.state.textFormatting.main">
                            <h2 :style="$store.state.textFormatting.main" class="font-weight-medium"> {{main}} </h2>
                            <br />
                        </div>
                        <ul v-if="entry.list">
                            <li v-for="item in entry.list" :key="item" :style="$store.state.textFormatting.main">
                                <h2 :style="$store.state.textFormatting.main" class="font-weight-medium"> {{item}} </h2>
                            </li>
                        </ul>
                        <br v-if="entry.list" />
                    </div>
                </v-card-text>
            </v-card>
            <br />
        </v-flex>
    </v-container>
</template>

<script>

import info from '../../shared/operational/infopopout.vue';

export default {
  name: 'privacynotice',
  components: {
  },
  data () {
    return {
        flippedy: true,
        cookiemonster: [
            { 
                'headers': [],
                'main': [
                    'This website uses cookies. By using the website and agreeing to this policy, you consent to our use of cookies in accordance with the terms of this policy.'
                ]
            },
            { 
                'headers': ['About Cookies'],
                'main': [
                    'Cookies are files, often including unique identifiers, that are sent by web servers to web browsers, and which may then be sent back to the server each time the browser requests a page from the server.',
                    'Cookies can be used by web servers to identity and track users as they navigate different pages on a website, and to identify users returning to a website.',
                    'Cookies may be either “persistent” cookies or “session” cookies. A persistent cookie consists of a text file sent by a web server to a web browser, which will be stored by the browser and will remain valid until its set expiry date (unless deleted by the user before the expiry date). A session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.'
                ]
            },
            { 
                'headers': ['Cookies on the website'],
                'main': [
                    'We only use session cookies on the website'
                ]
            },
            { 
                'headers': ['How we use cookies'],
                'main': [
                    'The session cookies used on the website are necessary for access and navigation and do not store any information about you or your computer. '
                ]
            },
            { 
                'headers': ['Third party cookies'],
                'main': [
                    'When you use the website, you will not be sent third party cookies.'
                ]
            },
            { 
                'headers': ['Blocking cookies'],
                'main': [
                    'Most browsers allow you to refuse to accept cookies. For example:'
                ],
                'list': [
                    'in Internet Explorer you can refuse all cookies by clicking “Tools”, “Internet Options”, “Privacy”, and selecting “Block all cookies” using the sliding selector;',
                    'in Firefox you can block all cookies by clicking “Tools”, “Options”, and un-checking “Accept cookies from sites” in the “Privacy” box.',
                    'in Google Chrome you can adjust your cookie permissions by clicking “Options”, “Under the hood”, Content Settings in the “Privacy” section. Click on the Cookies tab in the Content Settings.',
                    'in Safari you can block cookies by clicking “Preferences”, selecting the “Privacy” tab and “Block cookies”.'
                ]
            },
            { 
                'main': [
                    'Blocking all cookies will, however, have a negative impact upon the usability of many websites. If you block cookies, you may not be able to use certain features on the website, such as log on and accessing content.'
                ],
            },
            { 
                'headers': ['Deleting cookies'],
                'main': [
                    'You can also delete cookies already stored on your computer:'
                ],
                'list': [
                    'in Internet Explorer, you must manually delete cookie files;',
                    'in Firefox, you can delete cookies by, first ensuring that cookies are to be deleted when you “clear private data” (this setting can be changed by clicking “Tools”, “Options” and “Settings” in the “Private Data” box) and then clicking “Clear private data” in the “Tools” menu.',
                    'in Google Chrome you can adjust your cookie permissions by clicking “Options”, “Under the hood”, Content Settings in the “Privacy” section. Click on the Cookies tab in the Content Settings.',
                    'in Safari you can delete cookies by clicking “Preferences”, selecting the “Privacy” tab and “Remove All Website Data”.'
                ]
            },
            { 
                'main': [
                    'Obviously, doing this may have a negative impact on the usability of many websites.'
                ],
            },
        ],
        priv: [
            { 
                'headers': [],
                'main': [
                    'At BT we take your privacy very seriously and want you to trust us with your information. This privacy notice is published by British Telecommunications Plc through the Website bgpspotlight.bt.com. The purpose of this notice is to explain to you how we control, process, handle and protect your personal information at BT and while you browse or use the Website.',
                    'This notice tells you how we use your personal information but is not intended form a legal contract with you. It is also specific to BT and does not apply to any other companies or organisations that may collect your information.',
                    'We regularly review this privacy notice.  It was last updated on 28 November 2019.  We’ll post any changes to the privacy notice here and take reasonable steps to provide notice of those changes. We have included some definitions of key terms at the end of this document to assist you.'
                ]
            },
            { 
                'headers': [
                    'Who is collecting my information?'
                ],
                'main': [
                    'We are the \'Controller\' of your information. This simply means we collect your information and will also take responsibility for it.  We will also decide how and for what purpose your information should be used. '
                ]
            },
            { 
                'headers': [
                    'What information do you collect and what do you use it for?'
                ],
                'main': [
                    'We want to make sure you’re confident in knowing what personal information is being collected and why. So we\'ve broken down below the different types of information we will collect into different categories.',
                    'Personal information collected: '
                ],
                'list': [
                    'Your contact details and other information to confirm your identity and your communications with us. This includes your name, email address, passwords and credentials (such as the security questions and answers we have on your account).',
                    'Your communications with us, including emails, webchats and phone calls.  We’ll also keep records of any settings or communication preferences you choose.',
                    'Details of the Web Service, how it is performing and how you use it – including your call and browser (including IP address) records.'

                ]
            },
            { 
                'main': [
                    'What we use this information for:',
                ],
                'list': [
                    'To manage our contract with you. We need your name, contact details and information about how you use the Web Service to provide the services to you under our contract and to comply with security provisions. If you don’t give us the correct information or ask us to delete it, we will not be able to provide you with the Web Service.',
                    'Because it is in our legitimate business interests to use the information. We’ll use your personal information if we consider it is in our legitimate business interests so that we can operate as an efficient and effective business.  We may use your information to share within BT UK plc for administrative purposes; create aggregated and anonymised information for analysis; detect and prevent fraud; and secure and protect our network.'
                ]
            },
            { 
                'headers': [
                    'Cookies'
                ],
                'main': [
                    'We use information from cookies placed on your connected devices in order to provide the Web Service. We do this by using session-based cookies (which are not stored on your device/computer hard drive) to track how you use the Website and to keep you logged into the Website where applicable.',
                ],
            },
            { 
                'headers': [
                    'Who will you share my information with?'
                ],
                'main': [
                    'We will use your information within BT UK plc for any purposes related to the use of the Web Service. We may also share it with our suppliers where necessary to provide the service.',
                    'We may disclose personal information to law enforcement agencies or other public authorities so they can detect and stop crime, prosecute offenders and protect national security. We only share your personal information in accordance with applicable law; we have strong internal oversight of what we do and we take expert advice to inform our approach. ',
                    'We will also share personal information about you where we are under a legal obligation to disclose it to another person. These obligations arise because of a law that obliges us to disclose that information or because of a court order requiring disclosure of that information. '
                ],
            },
            { 
                'headers': [
                    'How long will you keep my information for?'
                ],
                'main': [
                    'We will continue to process your information for as long as is required to achieve the purpose for which it was collected, after which it will be deleted. We may also have legal or regulatory obligations which require us to keep data for specific periods before it is deleted.'
                ],
            },
            { 
                'headers': [
                    'How do I access a copy of the information you hold about me?'
                ],
                'main': [
                    'You have the right to access your information. You can request access to your information by emailing us at bgpspotlightadmin@bt.com. We monitor this inbox regularly to check for any requests that come in and will aim to do our best to get this back to you within 30 days. If for any reason we can’t get this back to you within that period, we will let you know why.',
                    'We’ll always try to help you with your request. We can decline if we believe doing so would adversely affect others or the law stops us.  And even though we have to complete your request free of charge, we are allowed to reject requests if they’re repetitive, you don’t have the right to ask for it, or the requests made are excessive.  If that’s the case, we’ll explain why we believe we don’t have to fulfil the request.'
                ],
            },
            { 
                'headers': [
                    'What if the information you hold is incorrect or I’d like you to stop using it?'
                ],
                'main': [
                    'You can ask us to amend or update your information to ensure it is correct and if you aren’t happy with the information we keep, you may request us to stop using your information or entirely delete your information as well. To exercise these rights please contact us at bgpspotlightadmin@bt.com.',
                    'We can decline a request, such as when we have a legal obligation to keep your information for a specific purpose.',
                    'We’ll always try to help you with your request.  We will assess your request on a case-by-case basis to make sure we give reasonable consideration to it and explain when we cannot fulfil it.'
                ],
            },
            { 
                'headers': [
                    'How to contact us and further details'
                ],
                'main': [
                    'You can get in touch with our data protection officer by email to cpo@bt.com or write to the address below and mark it for their attention.',
                    'If you’d like any more details, or you have comments or questions about our privacy policy, write to us at:',
                    'PO Box 2681, BT Centre, 81 Newgate Street, London, EC1A 7AJ',
                    'If you want to make a complaint on how we have handled your personal information, please contact our data protection officer who will investigate the matter and report back to you.  If you are still not satisfied after our response or believe we are not using your personal information in line with the law, you also have the right to complain to the data protection regulator in the country where you live or work. For the UK, that’s the Information Commissioner - https://ico.org.uk/'
                ],
            },
            { 
                'headers': [
                    'Glossary of key definitions'
                ],
                'main': [
                    '“BT”, “we”, “our” or “us” refer to British Telecommunications Plc.',
                    '“You” refers to the person(s) using the Website.',
                    '“Cookies” mean small text files downloaded onto ‘terminal equipment’ (for example a computer or smartphone) when the user accesses a website, allowing the website to recognise that user’s device and store some information about the user’s preferences or past actions.',
                    '“The Web Service” means any service provided to you by us via the Website.',
                    '“The Website” means www.bgpspotlight.bt.com.'
                ],
            },
        ],
    };
  },
  mounted () {
  },
  beforeMount() {  
  },
  methods: {
  }
};
</script>
